var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-column gr-10 text--text" }, [
    _c("div", { class: _setup.isMobile ? "text-h6 text-center" : "text-h5" }, [
      _vm._v(
        "\n    " +
          _vm._s(_setup.t("Зачем регистрироваться", _setup.options)) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "benefits-of-registration-list ga-10" },
      [
        _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
          _c("div", {
            staticClass: "ui-icon-reviews-40 ui-icon_type_40 brand",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-subtitle-1" }, [
            _vm._v(
              "\n        " +
                _vm._s(_setup.t("Отзывы пациентов", _setup.options)) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
            _vm._v(
              "\n        — " +
                _vm._s(
                  _setup.t("Уведомления о новых отзывах", _setup.options)
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(_setup.t("Приватный чат с автором", _setup.options)) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(_setup.t("Публикация ответов", _setup.options)) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
          _c("div", {
            staticClass: "ui-icon-puzzle-40 ui-icon_type_40 special",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-subtitle-1" }, [
            _vm._v(
              "\n        " +
                _vm._s(_setup.t("Формирование бренда", _setup.options)) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
            _vm._v(
              "\n        — " +
                _vm._s(_setup.t("Актуализация профиля", _setup.options)) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(
                  _setup.t("Бесплатная публикация интервью", _setup.options)
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(
                  _setup.t("Фотогалерея и видеовизитка клиники", _setup.options)
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column gr-4 flex-grow-1" }, [
          _c("div", {
            staticClass: "ui-icon-family-40 ui-icon_type_40 success",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-subtitle-1" }, [
            _vm._v(
              "\n        " +
                _vm._s(_setup.t("Новые пациенты", _setup.options)) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
            _vm._v(
              "\n        — " +
                _vm._s(_setup.t("Запись к врачам", _setup.options)) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(
                  _setup.t("Запись на услуги и диагностику", _setup.options)
                ) +
                "\n        "
            ),
            _c("br"),
            _vm._v(
              "— " +
                _vm._s(
                  _setup.t("Бесплатная выгрузка расписания", _setup.options)
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _setup.context.request.country.is_russia
          ? [
              _c(
                "div",
                { staticClass: "d-flex flex-column gr-4 flex-grow-1" },
                [
                  _c("div", {
                    staticClass: "ui-icon-ads-40 ui-icon_type_40 secondary",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.t("Умная реклама", _setup.options)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-body-2 text-secondary--text" },
                    [
                      _vm._v(
                        "\n          — " +
                          _vm._s(
                            _setup.t("Настраиваемый таргетинг", _setup.options)
                          ) +
                          "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        "— " +
                          _vm._s(
                            _setup.t(
                              "Спецразмещение клиник и врачей в каталоге",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column gr-4 flex-grow-1" },
                [
                  _c("div", {
                    staticClass: "ui-icon-rating-40 ui-icon_type_40 warning",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t("Партнерская программа", _setup.options)
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-body-2 text-secondary--text" },
                    [
                      _vm._v(
                        "\n          — " +
                          _vm._s(
                            _setup.t(
                              "Отсутствие рекламы на странице клиники",
                              _setup.options
                            )
                          ) +
                          "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        "— " +
                          _vm._s(
                            _setup.t(
                              "Отсутствие раздела «другие клиники города»",
                              _setup.options
                            )
                          ) +
                          "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        "— " +
                          _vm._s(
                            _setup.t(
                              "Сбор и визуализация аналитики",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column gr-4 flex-grow-1" },
                [
                  _c("div", {
                    staticClass: "ui-icon-pd-40 ui-icon_type_40 primary",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _setup.t(
                            "Другие преимущества «ПроДокторов»",
                            _setup.options
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "text-body-2 link-decoration-none primary--text",
                      attrs: {
                        href: `https://${_setup.context.site_expert.domain}/`,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _setup.t(
                              "Узнать про все преимущества",
                              _setup.options
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }